import styled from 'styled-components'

export const TabGroup = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: ${({ theme }) => theme.spacing.xxs}rem;
  border: 1px solid ${({ theme }) => theme.colors.neutralGray};
  border-radius: ${({ theme }) => theme.borderRadius.sm}rem;
  padding: ${({ theme }) => theme.spacing.xxs}rem;
`

export const TabButton = styled.button<{ $selected: boolean }>`
  border: none;
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSize.xs}rem;
  font-weight: 600;
  padding: ${({ theme }) => theme.spacing.xs}rem ${({ theme }) => theme.spacing.sm}rem;
  border-radius: ${({ theme }) => theme.borderRadius.sm}rem;
  background: ${({ theme, $selected }) => ($selected ? theme.colors.neutralGray : 'transparent')};
  color: ${({ theme, $selected }) => ($selected ? theme.colors.metalGray : theme.colors.iconGray)};
`
